import { getPlatformFeatureFlags } from './getFeatureFlags';

export const getSrcUrl = (
	tunnels: { resourceKey: string; tunnelUrl: string }[],
	extensionResource: string,
	defaultUrl: string,
	urlSafeContext: string,
): string => {
	const matchTunnel = tunnels.find((tunnel) => tunnel.resourceKey === extensionResource);

	const platformFeatureFlags = getPlatformFeatureFlags();

	const queryParams = new URLSearchParams({
		...(platformFeatureFlags.length > 0
			? { platformFeatureFlags: platformFeatureFlags.join(',') }
			: {}),
		// when tunnelling, pass hostname into query param to be passed into CSP
		...(matchTunnel
			? {
					hostname: window.location.hostname,
					ctx: urlSafeContext,
				}
			: {}),
	}).toString();

	const query = queryParams ? `?${queryParams}` : '';

	if (matchTunnel) {
		return `${matchTunnel.tunnelUrl}${query}`;
	}
	return `${defaultUrl}${query}`;
};
